import React from 'react';
import { PageContentHeaderTemplate } from 'themes/layouts';

function PageContentHeader(props) {
    return <PageContentHeaderTemplate {...props} />;
}

export default PageContentHeader;
